module.exports = __webpack_public_path__ + "img/ad55537543420d075d3cf254ab5020b5.gif";